import { Component, OnInit, EventEmitter } from '@angular/core';
import { BaseComponentService } from '../../../services/base-component.service';
import { IAslibModalOptions } from '@aslib/modal';

@Component({
  selector: 'gpa-liq-empenho',
  templateUrl: './liq-empenho.component.html',
  providers: [BaseComponentService],
  styles: [
    `
      .fieldRow {
      height:1px; border:none; color:#000; background-color:#000; margin-top: 0px; margin-bottom: 0px;'
      }
  `
  ]
})

export class LiqEmpenhoComponent extends BaseComponentService implements OnInit {

  static idFileEmpCaptured = new EventEmitter<number>();

  dataEnvioEmp: string;
  arquivosEmp: any[];
  arquivoEmp: any;
  habilitarCarregar: boolean;

  projetoIntegrado: string;
  showTabsNavigation = false;

  ngOnInit() {
    this.arquivoEmp = '';
    this.arquivosEmp = [];
    this.arquivoEmp = '';
    this.habilitarCarregar = true;

    sessionStorage.removeItem('IdEmp');

    this.projetoIntegrado = sessionStorage.getItem('ProjetoIntegrado');
  }

  async getArquivoEmp() {
    this.showTabsNavigation = false;
    sessionStorage.removeItem('IdEmp');

    if (this.isNullOrUndefinedOrEmpty(this.dataEnvioEmp)) {
      this.exibirAviso('Favor informar uma data para consulta dos EMPs.');
      return;
    }

    this.aslibLoadingService.start();

    try {
      await this.preencheComboDoisParametros('/api/EmpEnvio/ObterInfoEmpsEnviados/', 'arquivosEmp',
      this.projetoIntegrado, this.dataEnvioEmp, 'gpa');

      this.aslibLoadingService.complete();

      if (!this.arquivosEmp || this.arquivosEmp.length == 0) {
        this.exibirAviso('Não foram encontrados EMPs enviados para a data informada.');
        this.habilitarCarregar = true;
      }
      else {
        this.habilitarCarregar = false;
      }

    } catch (error) {
      this.aslibLoadingService.complete();
      this.exibirErro(error);
    }
  }

  emitterArquivoEmp(fileId: number): void {
    if (this.arquivoEmp === '') {
      this.exibirAviso('Selecione um arquivo para ser enviado.');
    } else {
      this.showTabsNavigation = false;
      setTimeout(() => {
        this.showTabsNavigation = true;
      }, 1000);
      sessionStorage.setItem("IdEmp", fileId.toString());
    }
  }


  openModalParametros(conteudo: any) {
    const options: IAslibModalOptions = {
      title: 'Parâmetros de Pagamento',
      backdrop: 'static',
      cancelarVisible: false,
      size: 'lg',
      content: conteudo
    };

    // Carrega um modal para exibição de mansagem
    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq-empenho/liq-empenho.component.ts